<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card style="min-width: 550px" class="card-authorization">
        <q-card-section class="header">
          <div class="text-h6 text-center" data-cy="card-authorization" id="title-card-authorization">
            <q-avatar v-if="iconTitle" size="20px" style="padding-right:24px;">
              <img :src="iconTitle" /> </q-avatar
            >{{ title }}
          </div>
        </q-card-section>
        <q-card-section class="container-auth q-pt-none q-col-gutter-y-sm">
          <slot name="body"></slot>
        </q-card-section>

        <q-card-actions align="center" class="text-primary container-actions">
          <q-btn
            flat
            label="Cancelar"
            padding="xs lg"
            v-close-popup
            @click="cancel()"
            :data-cy="cancelDataCy"
          />
          <q-btn
            :data-cy="dataCy"
            color="primary"
            padding="xs lg"
            @click="create()"
            :loading="isLoading"
          >
          <q-icon v-if="iconSuccess" :name="iconSuccess ? iconSuccess : ''" left/>
          {{ labelSuccess }}
          </q-btn>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { QDialog, QAvatar } from 'quasar';
export default {
  components: {
    QDialog,
    QAvatar
  },
  props: {
    value: {
      required: true
    },
    iconTitle: {
      required: false,
      type: String,
      default: () => ''
    },
    title: {
      required: false,
      type: String,
      default: () => ''
    },
    iconSuccess: {
      required: false,
      type: String,
      default: () => ''
    },
    labelSuccess: {
      required: false,
      type: String,
      default: () => 'Aceptar'
    },
    dataCy: {
      required: false,
      type: String,
      default: () => ''
    },
    cancelDataCy: {
      required: false,
      type: String,
      default: () => ''
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    cancel () {
      this.$emit('input', false);
    },
    create () {
      this.$emit('save');
    }
  },
  data () {
    return {
      valueLocal: this.value
    };
  },
  watch: {
    value: {
      handler: function () {
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.card-authorization {
  .header {
    padding-top: 18px;
    #title-card-authorization {
      font-family: DINPro;
      font-size: 24px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $azulcabecera;
    }
  }
  .container-auth {
    padding-top: 20px;
    padding-bottom: 25px;
    .title-option {
      font-family: DINPro;
      font-size: 15px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #5c5c5c;
      padding-bottom: 20px;
    }
  }
  &:deep() {
    .q-field--standard .q-field__control:before {
      border-bottom-color: rgba(89, 89, 89, 0.5) !important;
    }
  }
}
</style>
